import request from '@/utils/request';
/**
 * 获取菜单列表
 * @param {*} data 
 * @returns 
 */
export function listMenu(data) {
    return request({
        url: '/pa/xcx/paxcxpro/admin/sys-menu/list',
        method: 'post',
        data: data
    })
}
/**
 * 获取菜单树结构
 * @returns 
 */
export function treeMenu() {
    return request({
        url: '/pa/xcx/paxcxpro/admin/sys-menu/tree',
        method: 'get'
    })
}
/**
 * 新增菜单
 * @param {*} data 
 * @returns 
 */
export function addMenu(data) {
    return request({
        url: '/pa/xcx/paxcxpro/admin/sys-menu/add',
        method: 'post',
        data: data
    })
}
/**
 * 修改菜单
 * @param {*} data 
 * @returns 
 */
export function updateMenu(data) {
    return request({
        url: '/pa/xcx/paxcxpro/admin/sys-menu/update',
        method: 'post',
        data: data
    })
}
/**
 * 删除菜单
 * @param {*} data 
 * @returns 
 */
export function delMenu(data) {
    return request({
        url: '/pa/xcx/paxcxpro/admin/sys-menu/delete',
        method: 'post',
        data: data
    })
}
/**
 * 获取菜单详情
 * @param {*} data 
 * @returns 
 */
export function getMenu(data) {
    return request({
        url: '/pa/xcx/paxcxpro/admin/sys-menu/menuId',
        method: 'post',
        data: data
    })
}
/**
 * 获取路由
 * @returns 
 */
export function getRouters() {
    return request({
        url: '/pa/xcx/paxcxpro/admin/sys-menu/getRouters',
        method: 'get'
    })
}
/**
 * 根据角色ID查询菜单树结构
 * @param {*} roleId 
 * @returns 
 */
export function roleMenuTreeselect(roleId) {
    return request ({
        url: '/pa/xcx/paxcxpro/admin/sys-menu/roleMenuTreeSelect',
        method: 'post',
        data: roleId
    })
}